export default "__VITE_ASSET__24644c8b__$_?nuxt_component=async__"